import React, { useState, useRef, useEffect } from "react";
import Loader from "../../Components/Loader";
import Dropdown from "../../Components/Dropdown";
import Input from "../../Components/Input";
import DateInput from "../../Components/DateInput";
import ExpenseListController from "../Controllers/ExpenseListController";
import AddExpenseModal from "../Components/AddExpenseModal";
import filterIcon from "../../Assets/Icons/filter.png";
import leftBtuIcon from "../../Assets/Icons/back.png";
import downArrow from "../../Assets/Icons/chevron-down.png";
import editIcon from "../../Assets/Icons/edit.png";
import deleteIcon from "../../Assets/Icons/delete.png";
import { convertGMTToLocal } from "../../Utils/Validation";
import DeleteConfirmationModal from "../../Components/Modals/DeleteConformationModal";

const ExpenseListScreen = ({ expenseList, expenseLoading, expenseError, onRefresh, fetchExpenses }) => {
  const {
    showModal,
    openModal,
    closeModal,
    handleAddExpense,
    filters,
    setFilters,
    handleChange,
    statusOptions,
    openDropdown,
    toggleDropdown,
    dropdownRefs,
    applyFilters,
    resetFilters,
    loading,
    expenseFilterdList,
    filterError,
    setFilterError,
    currentPage,
    totalPages,
    handlePageChange, handleViewService,
    deleteLoading, expenseInfoRef,
    visiblePages, getStatusStyle, handleEditService,
    onExpenseDelete,
    deleteError, deleteSuccess,
    isDeleteModalOpen, handleCloseDeleteModal,
    callDeleteExpense, expenseDeleteRef,
    expenseListError,
  } = ExpenseListController(expenseList, onRefresh, fetchExpenses);

  const [showFilters, setShowFilters] = useState(false);

  return (
    <div>
      <div className="flexdisplaybetween" style={{ marginBottom: '15px' }}>
        <h2 className="tab-componrnt-title" >Expenses</h2>
        <button className="tasksScreen-apply-button" style={{ paddingTop: '10px', paddingBottom: '10px' }} onClick={openModal}>Add Expense</button>
      </div>

      {showModal && <AddExpenseModal isOpen={showModal} onClose={closeModal} editData={expenseInfoRef.current} onValueChange={onRefresh} />}

      {/* Filters */}
      <div style={styles.container}>
        <div style={styles.filtersHeader}>
          <button style={styles.filterButton} onClick={() => setShowFilters(!showFilters)}>
            <img src={filterIcon} alt="Filter" style={{ marginRight: '8px', width: 12 }} />
            <span>Filters</span>
          </button>
          <div>
            <img src={leftBtuIcon} style={styles.arrowBtn} alt="Prev" />
            <img src={leftBtuIcon} style={{ ...styles.arrowBtn, transform: 'rotate(180deg)' }} alt="Next" />
          </div>
        </div>
      </div>

      {showFilters && (
        <div className="tasksScreen-filters-container tasksScreen-open-filters">
          <div className="tasksScreen-filters">
            <div className="filter-field">
              <label style={{ ...styles.labaleStyle, display: "block" }}>Applied Date</label>
              <DateInput
                label="Applied Date"
                value={filters.approvedDate}
                onChange={(e) => handleChange("approvedDate", e.target.value)}
                placeholder="Select date"
                // width={220}
                max={new Date().toLocaleDateString("en-CA")}
              /></div>
            <div className="filter-field">
              <label style={{ ...styles.labaleStyle, display: "block" }}>Expense Date</label>
              <DateInput
                label="Expense Date"
                value={filters.expenseDate}
                onChange={(e) => handleChange("expenseDate", e.target.value)}
                placeholder="Select date"
              // width={220}
              /></div>
            <Input
              label="Total Amount"
              type="text"
              value={filters.amount}
              inputType="number"
              onChange={(e) => handleChange("amount", e.target.value)}
              placeholder="Enter amount"
              width={220}
            />
            <Dropdown
              ref={(el) => (dropdownRefs.current["Status"] = el)}
              isOpen={openDropdown === "Status"}
              toggleDropdown={() => toggleDropdown("Status")}
              label="Status"
              options={statusOptions}
              value={filters.status}
              onChange={(value) => handleChange("status", value)}
              width={220}
            />
          </div>
          <div className="tasksScreen-filter-buttons">
            <button onClick={applyFilters} className="tasksScreen-apply-button" style={{ gap: '5px', display: 'flex', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.5 : 1 }} disabled={loading}>
              {loading && <Loader loading={true} color="#fff" size="small" />}<span>Apply</span>
            </button>
            <button onClick={() => { setShowFilters(false); resetFilters() }} className="tasksScreen-cancel-button">Cancel</button>
            <button onClick={resetFilters} className="tasksScreen-reset-button">Reset</button>

            {filterError && <div className="list-error-msg">{filterError} </div>}
          </div>
        </div>
      )}

      {/* Table */}
      <div className="tasksScreen-task-table-wrapper">
        <table className="tasksScreen-task-table">
          <thead>
            <tr>
              <th>Expense Name</th>
              <th>Applied Date</th>
              <th style={{ textAlign: 'end' }}>Total Amount</th>
              <th style={{ textAlign: 'end' }}>Approved Amount</th>
              <th>Comment</th>
              <th>Added By</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody style={{ background: '#FFFFFF' }}>
            {expenseFilterdList.map((exp, idx) => (
              <tr key={idx}>
                <td>{exp?.expense_name || '--'}</td>
                <td>{exp?.created_at ? convertGMTToLocal(exp?.created_at, 'dd/MM/yyyy') : '--'}</td>
                <td style={{ textAlign: 'end' }}>{exp?.amount ? Number(exp?.amount).toFixed(2) : '--'}</td>
                <td style={{ textAlign: 'end' }}>{exp?.approved_amount ? Number(exp?.approved_amount).toFixed(2) : '--'}
                  {deleteSuccess[exp?.expenses[0]?.id] &&
                    <div style={{ color: 'green', textDecoration: 'none', paddingTop: 10 }} >{deleteSuccess[exp?.expenses[0]?.id]}</div>}
                  {deleteError[exp?.expenses[0]?.id] &&
                    <div style={{ color: 'red', paddingTop: 10 }} >{deleteError[exp?.expenses[0]?.id]}</div>}

                </td>
                <td>{exp.comment || '--'}</td>
                <td>{exp.added_by || '--'}</td>
                <td>
                  {/* <div > */}
                  <div style={{ padding: "3px 10px", borderRadius: "20px", width: 'fit-content', fontSize: 12, ...getStatusStyle(exp.expense_status_name) }}> {exp.expense_status_name}</div>
                  {/* </div> */}
                </td>
                <td>
                  {exp?.expense_status_name === "Approval Pending" ? (
                    <div style={{ display: "flex", gap: "2px" }}>
                      <button
                        className="tasksScreen-edit-button"
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          opacity: deleteLoading[exp?.expenses[0]?.id] ? 0.3 : 1
                        }}
                        onClick={() => { handleEditService(exp) }}
                        disabled={deleteLoading[exp?.expenses[0]?.id]}
                      >
                        <img src={editIcon} alt="Edit" style={{ width: "16px", height: "16px" }} />
                      </button>
                      <button
                        className="tasksScreen-delete-button"
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          opacity: deleteLoading[exp?.expenses[0]?.id] ? 0.3 : 1
                        }}
                        onClick={() => { onExpenseDelete(exp) }}
                        disabled={deleteLoading[exp?.expenses[0]?.id]}
                      >
                        <img src={deleteIcon} alt="Delete" style={{ width: "16px", height: "16px" }} />
                      </button>
                      {deleteLoading[exp?.expenses[0]?.id] &&
                        <span><Loader loading={deleteLoading[exp?.expenses[0]?.id]} color={'var(--primary-loader-color)'} size='small' /></span>
                      }

                    </div>
                  ) : (
                    <span onClick={() => { handleViewService(exp) }} style={{ color: "#5A55D2", textDecoration: "underline", cursor: "pointer" }}>View</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {loading && <Loader loading={loading} color={'var(--primary-loader-color)'} />}
      {expenseLoading && <Loader loading={expenseLoading} color={'var(--primary-loader-color)'} />}
      {expenseError && <div className="list-error-msg">{expenseError} </div>}
      {expenseListError && <div className="list-error-msg">{expenseListError} </div>}

      {/* Pagination */}
      <div className="tasksScreen-table-footer">
        <span className="tasksScreen-pagination-info">{`${currentPage}-${totalPages} of items`}</span>
        <div className="tasksScreen-pagination">
          <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
          </button>
          {visiblePages.map((page) => (
            <button
              key={page}
              className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}
          <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
          </button>
        </div>
      </div>
      {isDeleteModalOpen && <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        message={`Are you sure you want to delete ${expenseDeleteRef.current?.expense_name} ?`}
        onClose={handleCloseDeleteModal}
        onConfirm={() => {
          handleCloseDeleteModal(); // Close modal
          callDeleteExpense(expenseDeleteRef.current); // Perform delete operation
        }}
      />
      }
    </div>
  );
};

const styles = {
  container: {
    padding: "5px",
    backgroundColor: "#f8f9fa",
    border: "1px #EFF0F4 solid",
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  filterButton: {
    backgroundColor: "white",
    color: "var(--button-bg-color)",
    border: "1px var(--button-bg-color) solid",
    padding: "7px 13px",
    cursor: "pointer",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "Roboto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  arrowBtn: {
    marginRight: "5px",
    cursor: "pointer",
    width: "28px",
    height: "28px",
  },
};

export default ExpenseListScreen;
